import React from "react";
import "./button.css";
import { getSelectedSem, getBacklogStatus } from "./calculations";


// const calculateUptoSem = getSelectedSem();

function Button() {
  const handleClick = () => {
   const calculateUptoSem = getSelectedSem();
   const backlogStatus = getBacklogStatus();
   console.log("calculate upto ",calculateUptoSem);
  };

  return (
    <div>
      <button onClick={handleClick} className="submitButton">
        Submit
      </button>
    </div>
  );
}

export default Button;
